// Public surface of the E2E (`__SOLOMON_E2E__`) wallet harness. Everything
// here is inert in production — the global is never set in a real session.
// Existing consumers import from `./e2e` / `../e2e`, which resolve to this
// barrel, so the folder move is transparent to them.

export { readSolomonE2EChainOverride, readSolomonE2EOverrides } from "./overrides";
export { SolomonE2EWalletProvider, useSolomonE2ESigner, useSolomonE2EWallet } from "./provider";
export { createSmokeSigner } from "./signer";
export type { SmokeSigner } from "./signer";
export type {
    SolomonE2EChainOverride,
    SolomonE2EOverrides,
    SolomonE2ESignerOverride,
    SolomonE2EWalletOverride
} from "./types";
